import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { MovieDetailCardWithPosterProps } from "../../../@types/MovieDetailCard";
import { Image, LabelText } from "../../../components";

function MovieDetailCardWithPoster_1({
  movieTitle,
  movieDescription,
  genre,
  duration,
  director,
  cast,
  release_date,
  poster,
}: MovieDetailCardWithPosterProps) {
  const defaultLabelProps = {
    flexBasis: "10%",
  };
  return (
    <Box p="1rem" px="1.25rem" background="primary.200">
      <Flex
        gap="2.5rem"
        direction={{
          base: "column",
          md: "row",
        }}
      >
        <Image
          sx={{
            borderRadius: "10px",
            overflow: "hidden",
            flexBasis: "15%",
          }}
          maxH={{
            base: "30rem",
            md: "20rem",
          }}
          objectFit="cover"
          src={poster}
          alt={movieTitle}
        />

        <Box
          sx={{
            flexBasis: "80%",
          }}
          itemScope
          itemType="http://schema.org/Movie"
        >
          <Heading title={movieTitle} itemProp="name">
            {movieTitle}
          </Heading>
          <Heading
            size="small"
            textTransform="uppercase"
            mt="1rem"
            title="genre"
          >
            {genre}
          </Heading>
          <Text
            mt="1rem"
            fontWeight="normal"
            color="surface.400"
            title="description"
            itemProp="description"
          >
            {movieDescription}
          </Text>
          <Flex
            direction="column"
            mt="1.5rem"
            gap="0.25rem"
            itemProp="movies-info"
          >
            <LabelText
              labelProps={defaultLabelProps}
              label="director"
              title={director}
              itemProp="director"
              text={director}
            />
            <LabelText
              labelProps={defaultLabelProps}
              label="cast"
              title="cast"
              itemProp="movie-cast"
              text={cast}
            />
            <LabelText
              labelProps={defaultLabelProps}
              label="release on"
              title="release date"
              itemProp="datePublished"
              text={release_date}
            />
            <LabelText
              labelProps={defaultLabelProps}
              label="duration"
              title="movie-duration"
              itemProp="movie-duration"
              text={duration}
            />
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}

export default MovieDetailCardWithPoster_1;
